export function resolveSurveyCampaignUrl(_redirectUrl: string, newProjectId?: string): string {
  if (!newProjectId) return _redirectUrl

  const match = window.location.pathname.match(/\/projects\/[^/]+\/story_categories\/(\d+)\//)
  if (!match) return _redirectUrl

  const storyCategoryId = match[1]
  const currentTab = new URLSearchParams(window.location.search).get('tab_name')

  const projectOption = document.querySelector<HTMLOptionElement>(
    `#project-select option[value="${newProjectId}"]`
  )

  if (projectOption?.dataset.url) {
    const url = new URL(projectOption.dataset.url, window.location.origin)
    if (currentTab) url.searchParams.set('tab_name', currentTab)
    url.searchParams.set('source_page', 'survey_campaign')
    return url.toString()
  }

  const url = new URL('/story_categories', window.location.origin)
  url.searchParams.set('manage_for_type', 'Project')
  url.searchParams.set('manage_for_id', newProjectId)
  url.searchParams.set('source_page', 'project_toolbar')
  if (currentTab) url.searchParams.set('tab_name', currentTab)
  return url.toString()
}
